var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "parent outline" }, [
    _c("div", { staticStyle: { display: "inline-block" } }, [
      _c(
        "p",
        {
          staticStyle: {
            "font-size": "32px",
            "font-weight": "bold",
            margin: "0px",
            width: "49%",
            float: "left"
          }
        },
        [_vm._v(_vm._s(_vm.qbFile))]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticStyle: {
            "font-size": "32px",
            "font-weight": "bold",
            margin: "0px",
            width: "49%",
            "text-align": "right",
            float: "right"
          }
        },
        [_vm._v("Invoice")]
      )
    ]),
    _vm._v(" "),
    _c(
      "table",
      { staticClass: "hidetable", staticStyle: { border: "none" } },
      [
        _c("tr", [
          _c("td", [_vm._v("Bill To")]),
          _vm._v(" "),
          _c("td", { staticStyle: { width: "25%" } }, [
            _c("table", [
              _vm._m(0),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v(_vm._s(_vm.getDate()))]),
                _vm._v(" "),
                _c("td")
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm._l(_vm.addresses, function(address, index) {
          return _c("tr", [
            _c("td", { staticStyle: { padding: "0px", height: "25px" } }, [
              _c("p", { staticStyle: { margin: "0px" } }, [
                _vm._v(_vm._s(address))
              ])
            ])
          ])
        })
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "table",
      {
        staticStyle: {
          width: "50%",
          "margin-right": "0px",
          "margin-left": "auto"
        }
      },
      [
        _vm._m(1),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v(_vm._s(_vm.ponumber))]),
          _vm._v(" "),
          _c("td", [_c("p", [_vm._v(_vm._s(_vm.column_data[0]))])])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "table",
      [
        _vm._m(2),
        _vm._v(" "),
        _c("tr", { staticClass: "hideborder" }, [
          _c("td"),
          _vm._v(" "),
          _c("td", [
            _c("p", { staticStyle: { "white-space": "pre-wrap" } }, [
              _vm._v(_vm._s(_vm.column_data[4]))
            ])
          ]),
          _vm._v(" "),
          _c("td"),
          _vm._v(" "),
          _c("td")
        ]),
        _vm._v(" "),
        _vm.overlap == true
          ? _c("tr", { staticClass: "hideborder" }, [_vm._m(3)])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.times, function(time, index) {
          return time[6] != null
            ? _c("tr", { staticClass: "hideborder" }, [
                _c(
                  "td",
                  { staticStyle: { height: "25px" } },
                  _vm._l(time[6], function(val, i) {
                    return time[6][i] != 0
                      ? _c("p", { staticStyle: { "text-align": "right" } }, [
                          _vm._v("\n\t\t\t\t" + _vm._s(val) + "\n\t\t\t")
                        ])
                      : _vm._e()
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { height: "25px" } },
                  _vm._l(time[5].split("\n"), function(val, i) {
                    return time[6][i] != 0
                      ? _c("p", [
                          _vm._v("\n\t\t\t\t" + _vm._s(val) + "\n\t\t\t")
                        ])
                      : _vm._e()
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { height: "25px" } },
                  _vm._l(time[8], function(val, i) {
                    return time[6][i] != 0
                      ? _c("p", [
                          _vm._v("\n\t\t\t\t" + _vm._s(val) + "\n\t\t\t")
                        ])
                      : _vm._e()
                  }),
                  0
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { height: "25px" } },
                  _vm._l(time[9], function(val, i) {
                    return time[6][i] != 0
                      ? _c("p", [
                          _vm._v("\n\t\t\t\t" + _vm._s(val) + "\n\t\t\t")
                        ])
                      : _vm._e()
                  }),
                  0
                )
              ])
            : _vm._e()
        }),
        _vm._v(" "),
        _vm._l(_vm.materials, function(material, index) {
          return _c("tr", { staticClass: "hideborder" }, [
            _c("td", { staticStyle: { height: "25px" } }, [
              material[3] != null
                ? _c("p", { staticStyle: { "text-align": "right" } }, [
                    _vm._v(_vm._s(material[3]))
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { height: "25px" } }, [
              material[2] != null
                ? _c("p", [_vm._v(_vm._s(material[2]))])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { height: "25px" } }, [
              material[4] != null
                ? _c("p", [_vm._v(_vm._s(material[4]))])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("td", { staticStyle: { height: "25px" } }, [
              material[5] != null
                ? _c("p", [_vm._v(_vm._s(material[5]))])
                : _vm._e()
            ])
          ])
        }),
        _vm._v(" "),
        _c("tr", [
          _c("td", { attrs: { colspan: "2" } }, [
            _vm.showMiscText == true
              ? _c("p", [_vm._v("Thank you for your business.")])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("td", { attrs: { colspan: "2" } }, [
            _c("b", { staticStyle: { float: "left", "font-size": "32px" } }, [
              _vm._v("Total")
            ]),
            _c("p", { staticStyle: { float: "right" } }, [
              _vm._v("USD " + _vm._s(_vm.totalUSD))
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c(
            "td",
            {
              staticStyle: { "text-align": "center" },
              attrs: { colspan: "4" }
            },
            [
              _vm.showMiscText == true
                ? _c("p", [
                    _vm._v(
                      "Terms of payment is Net 15 days, 2.5% compounded monthly interest on all late payments. Our Terms of Use located at www.LDpowerautomation.com/TermsofUse.pdf apply."
                    )
                  ])
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c("tr", [
          _c(
            "td",
            {
              staticStyle: { "text-align": "center" },
              attrs: { colspan: "4" }
            },
            [
              _vm.showMiscText == true
                ? _c("p", [
                    _vm._v(
                      "For questions, you can contact us at: tel +1 310 7071115, fax +1 310 6269486, e-mail accounting@ldpa.us"
                    )
                  ])
                : _vm._e()
            ]
          )
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_c("b", [_vm._v("Date")])]),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("Invoice #")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", [_c("b", [_vm._v("P.O. No.")])]),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("Project")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticStyle: { width: "10%" } }, [
        _c("p", { staticStyle: { "text-align": "center" } }, [
          _vm._v("Quantity")
        ])
      ]),
      _vm._v(" "),
      _c("td", [
        _c("p", { staticStyle: { "text-align": "center" } }, [
          _vm._v("Description")
        ])
      ]),
      _vm._v(" "),
      _c("td", { staticStyle: { width: "15%" } }, [
        _c("p", { staticStyle: { "text-align": "center" } }, [_vm._v("Rate")])
      ]),
      _vm._v(" "),
      _c("td", { staticStyle: { width: "15%" } }, [
        _c("p", { staticStyle: { "text-align": "center" } }, [_vm._v("Amount")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: { padding: "0px", height: "0px" },
        attrs: { colspan: "4" }
      },
      [
        _c("div", { staticClass: "overlap" }, [
          _vm._v(
            "Multiple times and minimum time applied detected, check for overlaps"
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6176cdc5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6176cdc5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/layout_10.vue
// module id = 772
// module chunks = 0